import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WeeklyPlanView from "../components/WeeklyPlan/WeeklyPlanView";
import { useWeeklyPlan } from "../hooks/useWeeklyPlan";
import { fetchUserCards } from "../api/userCards";
import { buildActivityColumns, buildListDescriptorsFromRows } from "../lib/activityColumns";

export default function PlanPage() {
  const navigate = useNavigate();
  const [listColumns, setListColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  const [userCards, setUserCards] = useState([]);
  const { plan, addToSlot, removeFromSlot, dayDates, getSlotKey, dateRangeLabel } = useWeeklyPlan();

  useEffect(() => {
    const loadData = async () => {
      try {
        const rows = await fetchUserCards({ category: "C" }).catch(() => []);
        setUserCards(rows);
      } catch (err) {
        console.error("Error loading plan data:", err);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    const descriptors = buildListDescriptorsFromRows(userCards);
    setListColumns(descriptors);
    setColumns(buildActivityColumns(descriptors, userCards));
  }, [userCards]);

  const labels = listColumns.map((c) => c.label);

  return (
    <WeeklyPlanView
      columns={columns}
      labels={labels}
      listDescriptors={listColumns}
      plan={plan}
      addToSlot={addToSlot}
      removeFromSlot={removeFromSlot}
      dayDates={dayDates}
      getSlotKey={getSlotKey}
      dateRangeLabel={dateRangeLabel}
      onBack={() => navigate("/archiv")}
    />
  );
}
